import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({ prefix: 'tw-' });

const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export { cn };
